import getSorter from './getSorters'

export default function sortHubs(rowA, rowB) {
  const a = rowA.groupByVal ? rowA.groupByVal.toLowerCase() : rowA.original.displayName.toLowerCase()
  const b = rowB.groupByVal ? rowB.groupByVal.toLowerCase() : rowB.original.displayName.toLowerCase()

  return getSorter('hubs', a, b)
}
